const DEFAULT_LOCALE = "es-CR";

export const formatDate = (value: string, locale = DEFAULT_LOCALE) => {
  if (!value) {
    return "";
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return parsed.toLocaleDateString(locale, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export default formatDate;
